module.exports = __webpack_public_path__ + "img/Hero@3x.c7fb3778.png";